import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";

@Component({
    selector: 'public-router-outlet',
    template: `
    <router-outlet></router-outlet>
  `,
    imports: [
        RouterOutlet
    ],
    styles: [`
  `]
})
export class PublicRouterOutletComponent {

}
